import { render, staticRenderFns } from "./InvoicesFBMTable.vue?vue&type=template&id=f1316816&scoped=true"
import script from "./InvoicesFBMTable.vue?vue&type=script&lang=js"
export * from "./InvoicesFBMTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesFBMTable.vue?vue&type=style&index=0&id=f1316816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1316816",
  null
  
)

export default component.exports